/** @format */

export enum ShippingMethod {
    COLLECTION = 'collection',
    DROPOFF = 'dropoff',
}

export enum PrinterOption {
    PRINTER = 'printer',
    PRINTERLESS = 'printerless',
}

export enum ShippingOptionType {
    SHIPPING = 'shipping',
    COLLECTION = 'collection',
}

// eslint-disable-next-line @typescript-eslint/naming-convention -- Legacy code: do not use as an example.
export enum ShippingOptionTypeEnum {
    SHIPPING = 1,
    COLLECTION = 3,
}

export const deShippingHelpArticle =
    'https://de.help.mpb.com/de/articles/13726461-informationen-zur-lieferung';

export const deShippingHelpArticleConsolidatedHC =
    'https://help.mpb.com/de/articles/852099-informationen-zu-lieferung-und-versand';
